<template>
  <div style="position: relative;">
    <!-- 左侧图例 -->
    <div v-if="showCompany === 1 || zoomNow > 8" class="legend">
      <p class="legend_title">图例</p>
      <template v-for="item in (showAll ? listOfOption : selectOptions)">
        <div :key="item" class="legend_li">
          <p class="square" :style="{backgroundColor: optionsLengend[item]}"></p>
          <p class="txt">{{ item }}</p>
        </div>
      </template>
    </div>
    <!-- 右侧选择 -->
    <div style="text-align: right;
    margin-right: 30px;
    position: absolute;
    z-index: 10;
    top:20px;
    right:20px;
    margin-bottom: 10px;">
      <el-radio-group 
        style="margin-right: 20px; margin-top: -2px;"
        v-model="showCompany" 
        size="small" 
        @change="getAllCompanys">
        <el-radio-button :label="1">企业产能</el-radio-button>
        <el-radio-button :label="2">区域汇总</el-radio-button>
      </el-radio-group>
      <el-select
          v-model="selectTypes"
          multiple
          collapse-tags
          size="small"
          placeholder="请选择种类">
        <el-option
            v-for="item in listOfOption"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="changeSelect">确认</el-button>
    </div>
    <div class="echartLeft" style="margin-top: -24px;">
      <div id="container" style="height: 500px;"></div>
    </div>
    <div class="content">
      <div class="detail" v-if="detailLlag">
        <img @click="closeDio" src="../../../assets/images/confirm.png" alt="">
        <p>{{ verneCompanyDetail.company_name }}</p>
        <div class="top">
          <span>品种</span>
          <em>{{ verneCompanyDetail.varieties }}</em>
        </div>
        <div class="top" style="margin-top: 0;">
          <span>国别</span>
          <em>{{ verneCompanyDetail.country ? verneCompanyDetail.country :'' }}</em>
        </div>
        <div class="top" style="margin-top: 0;">
          <span>地址</span>
          <em>{{ verneCompanyDetail.area_name }}</em>
        </div>
        <div class="bom" style="margin-top: 0;">
          <span>总产能</span>
          <em>{{ verneCompanyDetail.sum_capacity }}</em>
        </div>
      </div>
    </div>

    <div class="detailDetail">
    </div>
  </div>
</template>

<script>
import AMap from 'AMap'
import * as _ from "lodash";
import {adipicMapDetail, methanolMapSelect, companyDetail} from '@/api/map'
import $ from 'jquery'

export default {
  data() {
    return {
      mapM: null,
      mapCenter: null,
      markers: [], //所有点
      zoomNow: 5,
      oneB: [
        {
          "name": "北京市",
          "center": "116.405285,39.904989",
          "type": 0,
          "subDistricts": []
        }
      ],
      selectTypes: [],
      listOfOption: [],
      showCompany: 1,
      allCompnays: null,
      polylines: [],
      markertNow: [], //选中的红
      markertNowPOsition: null, // 选中的位置
      canShowDetailDetail: 1,//默认 不显示  0 显示
      //选中的某坐标
      onePosition: [],
      oneCompanyCode: '',
      varieties: '',
      companys: [],
      provinceCompanys: [],
      oneType: '',
      verneCompanyDetail: {},
      detailLlag: false,
      optionsLengend: {
        '苯加氢': 'rgb(250, 154, 6)',
        '石油苯': 'rgb(3, 182, 236)',
        '苯乙烯': 'rgb(244, 227, 14)',
        'PS': 'rgb(82, 55, 215)',
        'EPS': 'rgb(255, 133, 132)',
        'ABS': 'rgb(180, 189, 58)',
        '己内酰胺': 'rgb(194, 240, 205)',
        '己二酸': 'rgb(99, 108, 173)'
      },
      showAll: true,
      selectOptions: []
    }
  },
  created() {
    this.getDistinctVarieties()
  },
  mounted() {
    let dHeight = $(window).height() - 170;
    $('#container').height(dHeight + 'px');
    this.mapCenter = new AMap.LngLat(116.397428, 39.90923);
    this.mapM = new AMap.Map('container', {
      zoom: this.zoomNow
    });
    // 地图控件
    // AMap.plugin(['AMap.ToolBar'], () => {
    //   this.mapM.addControl(new AMap.ToolBar({
    //     map: this.mapM
    //   }));
    // });
    this.maker()
    this.mapM.on("zoomend", () => {
      let zoom = this.mapM.getZoom();
      //关联点出现不监听
      this.getZoomData(zoom);
    });
  },
  methods: {

    /**
     * 获取下拉框
     */
    getDistinctVarieties() {
      methanolMapSelect().then(res => {
        this.listOfOption = res['data'];
      })
    },

    /**
     * 切换企业和汇总
     * @param num
     */
    changeButton(num) {
      this.showCompany = num;
      this.getAllCompanys();
    },
    /**
     * 确认选择下拉框
     */
    changeSelect() {
      this.getAllCompanys();
    },
    /**
     * 获取地图点位
     */
    maker() {
      let that = this;
      AMapUI.loadUI(['geo/DistrictExplorer'], function (DistrictExplorer) {
        initPage(DistrictExplorer);
      });

      function initPage(DistrictExplorer) {
        //创建一个实例
        var districtExplorer = new DistrictExplorer({
          map: that.mapM //关联的地图实例
        });

        var adcode = 100000; //全国的区划编码

        districtExplorer.loadAreaNode(adcode, function (error, areaNode) {

          if (error) {
            console.error(error);
            return;
          }

          //绘制载入的区划节点
          renderAreaNode(districtExplorer, areaNode);
        });
      }

      function renderAreaNode(districtExplorer, areaNode) {

        //清除已有的绘制内容
        districtExplorer.clearFeaturePolygons();

        //just some colors
        var colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00"];

        //绘制子级区划
        districtExplorer.renderSubFeatures(areaNode, function (feature, i) {

          var fillColor = colors[i % colors.length];
          var strokeColor = colors[colors.length - 1 - i % colors.length];

          return {
            cursor: 'default',
            bubble: true,
            strokeColor: strokeColor, //线颜色
            strokeOpacity: 1, //线透明度
            strokeWeight: 1, //线宽
            fillColor: fillColor, //填充色
            fillOpacity: 0.35, //填充透明度
          };
        });

        //绘制父级区划，仅用黑色描边
        districtExplorer.renderParentFeature(areaNode, {
          cursor: 'default',
          bubble: true,
          strokeColor: 'black', //线颜色
          fillColor: null,
          strokeWeight: 3, //线宽
        });

        //更新地图视野以适合区划面
        that.mapM.setFitView(districtExplorer.getAllFeaturePolygons());
      }

      this.getAllCompanys();
    },
    /**
     * 获取地图数据
     */
    getAllCompanys() {
      const rLoading = this.openLoading();
      let type = '';
      if (this.selectTypes.length > 0) {
        this.showAll = false;
        this.selectOptions = JSON.parse(JSON.stringify(this.selectTypes))
        type = this.selectTypes.join(',');
      } else {
        this.showAll = true;
        this.selectOptions = []; 
      }
      adipicMapDetail({type: type, showCompany: this.showCompany, mapFlag: 2})
          .then((suc) => {
            if (suc['data']) {
              this.allCompnays = suc['data'];
              this.getZoomData(this.zoomNow);
              // this.maker();
            } else {
              this.$message.info('暂无数据');
            }
            rLoading.close()
          }).catch((err) => {
        rLoading.close()
      });
    },
    //根据级别显示数据
    getZoomData(zoom) {
      this.zoomNow = zoom;
      if (this.polylines.length === 0) {
        if (this.showCompany === 1) {
          if (this.allCompnays) {
            this.companys = this.allCompnays[`companysInfo`];//
            this.setMap();
          }
        } else {
          if (_.includes([0, 1, 2, 3, 4, 5, 6], zoom)) {
            // console.log('[0,1, 2,3,4,5,6] :' + zoom)
            this.provinceCompanys = this.allCompnays[`provincesInfo`];
            this.setNoDetailMap('province');
          } else if (_.includes([7, 8], zoom)) {
            // console.log('[7, 8] :' + zoom)
            this.provinceCompanys = this.allCompnays[`citysInfo`];
            this.setNoDetailMap('city');
          } else if (zoom > 8) {
            // console.log('> 8 :' + zoom)
            this.companys = this.allCompnays[`companysInfo`];//
            // this.cokeCompanys=this.allCompnays[`companysInfo`][0].coke//焦化
            // this.steelCompanys=this.allCompnays[`companysInfo`][2].steel
            this.setMap();
          }
        }
      }
    },
    /**
     * 省市汇总
     * @param str
     */
    setNoDetailMap(str) {
      this.clearPoint();
      let marker1;

      let icon1 = new AMap.Icon({
        image: require('@/assets/map/redXing.png'),
        size: new AMap.Size(24, 24)
      });
      marker1 = new AMap.Marker({
        icon: icon1,
        position: this.oneB[0].center.split(','),
        offset: new AMap.Pixel(-12, -12),
        // zIndex: 101,
        title: this.oneB[0].name,
        map: this.mapM
      });
      this.markers.push(marker1);
      //tbule  省 市
      if (this.provinceCompanys) {
        for (var i = 0; i < this.provinceCompanys.length; i++) {
          let company = this.provinceCompanys[i];
          if (company.lat != null && company.lng != null) {
            this.clickYuanHidden(company.lng, company.lat, company[`${str}`], company[`capacity`], company['varietiesList']);
          }
        }
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    /**
     * 设置地图
     */
    setMap() {
      this.clearPoint();
      let marker1 = null;

      let icon1 = new AMap.Icon({
        image: require('@/assets/map/redXing.png'),
        size: new AMap.Size(24, 24)
      });
      marker1 = new AMap.Marker({
        icon: icon1,
        position: this.oneB[0].center.split(','),
        offset: new AMap.Pixel(-12, -12),
        // zIndex: 101,
        title: this.oneB[0].name,
        map: this.mapM
      });
      this.markers.push(marker1);
      //天蓝 钢厂
      for (var i = 0; i < this.companys.length; i++) {
        let company = this.companys[i];
        if (company.lat != null && company.lng != null) {
          let marker;
          let images = require('@/assets/map/mark_bs.png');

          //苯加氢\石油苯\苯乙烯\PS\EPS\ABS\己内酰胺\己二酸
          if (company.varieties === '苯加氢') {
            images = require('@/assets/map/mark_1.png');
          } else if (company.varieties === '石油苯') {
            images = require('@/assets/map/mark_2.png');
          } else if (company.varieties === '苯乙烯') {
            images = require('@/assets/map/mark_3.png');
          } else if (company.varieties === 'PS') {
            images = require('@/assets/map/mark_4.png');
          } else if (company.varieties === 'EPS') {
            images = require('@/assets/map/mark_5.png');
          } else if (company.varieties === 'ABS') {
            images = require('@/assets/map/mark_6.png');
          } else if (company.varieties === '己内酰胺') {
            images = require('@/assets/map/mark_7.png');
          } else if (company.varieties === '己二酸') {
            images = require('@/assets/map/mark_8.png');
          }

          let iconM = new AMap.Icon({
            image: images
          });
          marker = new AMap.Marker({
            icon: iconM,
            position: [company.lng, company.lat],
            title: company.companyName,
            map: this.mapM
          });
          marker.on('click', (e) => {
            this.mapM.remove(this.polylines);
            this.polylines = [];
            $('.detailDetail').html('');
            this.onePosition = [company.lng, company.lat];
            this.oneCompanyCode = company.companyCode;
            this.varieties = company.varieties;
            this.oneType = '4';
            //this.getCompanyOne(this.onePosition)
            this.getOneDetail(this.onePosition);
          });
          this.markers.push(marker);
        }
      }
      if (this.markertNow.length > 0) {
        this.markNowAdd(this.markertNowPOsition);
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    clickYuanHidden(lng, lat, str, capacity, varietiesList) {
      let iconM = new AMap.Icon({
        image: require('@/assets/map/mark_zi.png'),
        size: new AMap.Size(24, 24)
      });
      let marker = new AMap.Marker({
        icon: iconM,
        position: [lng, lat],
        title: str,
        map: this.mapM,

      });
      let markerContent = document.createElement("div");
      markerContent.className = 'markerDiv';
      markerContent.style.backgroundColor = '#3072f7';
      markerContent.style.borderRadius = '50%';
      markerContent.style.height = '85px';
      markerContent.style.width = '85px';
      markerContent.style.wordBreak = 'break-all';
      markerContent.style.textAlign = 'center';
      markerContent.style.padding = '5px';
      markerContent.style.boxShadow = '#5d5d5d 0px 0px 4px 0px';
      markerContent.style.display = 'table';
      let tempstr = '';
      varietiesList.map(item => {
        tempstr += `${item['varieties']} : ${item['sum'] ? item['sum'] : 0}   `
      })
      markerContent.title = tempstr


      let testContent = document.createElement("div");
      testContent.className = 'markerDivText';
      testContent.style.wordBreak = 'break-all';
      testContent.style.textAlign = 'center';
      testContent.style.display = 'table-cell';
      testContent.style.verticalAlign = 'middle';
      markerContent.appendChild(testContent);

      // 点标记中的文本
      var markerSpan = document.createElement("p");
      markerSpan.className = 'marker';
      markerSpan.innerHTML = str;
      markerSpan.style.position = 'relative';
      markerSpan.style.color = '#ffffff';
      markerSpan.style.padding = '9px 10px 0 10px';
      markerSpan.style.whiteSpace = 'break-word';
      markerSpan.style.fontSize = '12px';
      markerSpan.style.fontWeight = '600';
      // markerSpan.style.display = 'inline-block';
      markerSpan.style.lineHeight = '12px';
      testContent.appendChild(markerSpan);
      for (let i = 0; i < (varietiesList.length < 2 ? 1 : 2); i++) {
        let markerSpan2 = document.createElement("span");
        markerSpan2.className = 'marker';
        markerSpan2.innerHTML = `${varietiesList[i]['varieties']}:${varietiesList[i]['sum'] ? varietiesList[i]['sum'] : 0}`;
        markerSpan2.style.position = 'relative';
        markerSpan2.style.color = '#ffffff';
        markerSpan2.style.padding = '2px 5px 0 5px';
        markerSpan2.style.fontSize = '12px';
        markerSpan2.style.display = 'inline-block';
        testContent.appendChild(markerSpan2);
        marker.setContent(markerContent); //更新点标记内容
      }
      marker.on('click', (e) => {
        marker = null;

        this.mapM.remove([lng, lat]);
        this.clickYuanHidden(lng, lat, str, capacity, varietiesList);

      });
      this.markers.push(marker);
    },
    /**
     * 添加点
     */
    markNowAdd(position) {
      let iconM = new AMap.Icon({
        image: require('@/assets/map/mark_r.png'),
      });
      let marker = new AMap.Marker({
        icon: iconM,
        position: position,
        map: this.mapM
      });
      this.markertNowPOsition = position;
      this.markertNow.push(marker);
    },
    /**
     * 清除点
     */
    clearPoint() {
      if (this.zoomNow < 8) {
        this.mapM.remove(this.markertNow);
        this.markertNow = [];
        this.markertNowPOsition = null;
      }
      this.mapM.remove(this.markers);
      this.mapM.remove(this.polylines);
      this.polylines = [];
      this.markers = [];
    },

    //移除当前选中的企业坐标
    removeNowMarket() {
      this.mapM.remove(this.markertNow);
      this.markertNow = [];
      this.markertNowPOsition = null;
    },
    getOneDetail(position) {
      //标记当前点
      this.removeNowMarket();

      this.markNowAdd(position);

      const rLoading = this.openLoading();
      let param = {
        user: this.LOGIN_USER_ID,//'admin',//
        companyCode: this.oneCompanyCode,
        varieties: this.varieties,
        type: this.oneType
      };
      companyDetail(param)
          .then((suc) => {
            if (suc['data'] && suc['data'].length > 0 && suc['data'][1] != null) {
              console.log(suc['data'])
              this.canShowDetailDetail = suc['data'][0].show;
              for (const positionKey in suc['data'][1]) {
                suc['data'][1][positionKey] = suc['data'][1][positionKey] == null ? '暂无数据' : suc['data'][1][positionKey];
              }

              _.forEach(suc['data'][2], (item, index) => {
                for (const positionKey in item) {
                  item[positionKey] = item[positionKey] == null || '' ? '暂无数据' : item[positionKey];
                }
              });
              _.forEach(suc['data'][3], (item, index) => {
                for (const positionKey in item) {
                  item[positionKey] = item[positionKey] == null || '' ? '暂无数据' : item[positionKey];
                }
              });
              _.forEach(suc['data'][4], (item, index) => {
                for (const positionKey in item) {
                  item[positionKey] = item[positionKey] == null || '' ? '暂无数据' : item[positionKey];
                }
              });
              this.verneCompanyDetail = suc['data'][1];
              this.verneCompanyDetail.deviceInfos = suc['data'][2];
              this.verneCompanyDetail.materialSupplies = suc['data'][3];
              this.verneCompanyDetail.productFlows = suc['data'][4];
              this.createInfo(position);
            } else {

              this.$message.info('暂无数据');
            }
            rLoading.close()
          }).catch(() => {
        rLoading.close()
      });
    },
    //构建自定义信息窗体
    createInfo(position) {
      this.detailLlag = true;
    },
    closeDio() {
      this.detailLlag = false;
    },
  }
}
</script>

<style scoped lang="less">
.detail {
  position: absolute;
  top: 20%;
  right: 44px;
  width: 300px;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  padding: 50px 30px;
  img {
    position: absolute;
    top: 17px;
    right: 21px;
    cursor: pointer;
  }
  p {
    font-size: 16px;
  }

  .top {
    margin-top: 10px;
    border-bottom: none !important;
  }

  .top, .bom {
    border: 1px solid #F4E4E4;
    width: 305px;
    display: flex;
    span {
      display: block;
      padding-left: 20px;
      width: 100px;
      min-height: 44px;
      background: #FDF3F3;
      display: flex;
      align-items: center;
    }

    em {
      flex: 1;
      display: block;
      padding: 0 6px 0 20px;
      line-height: 30px;
      background: #FFFFFF;
      font-style: normal;
      display: flex;
      align-items: center;
    }
  }
}
.legend {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  padding: 10px 30px 10px 20px;
  .legend_title {
    font-size: 16px;
    margin-bottom: 6px;
  }
  .legend_li {
    display: flex;
    align-items: center;
    height: 30px;
    .square {
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }
    .txt {
      line-height: 30px;
    }
  }
}
</style>
